import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { Link2, Trash2, PackageSearch } from "lucide-react";

export function useGarmentOptions() {
  const [garments, setGarments] = useState([]);
  useEffect(() => { api.get("/garments").then(r => setGarments(r.data)); }, []);
  return garments;
}

export function SkuLinkRow({ item, garments, onLinked }) {
  const [gid, setGid] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const tid = (item.sku || "").replace(/[^a-zA-Z0-9]/g, "-");
  const link = async () => {
    setBusy(true); setErr("");
    try { const r = await api.post("/sku-mappings", { sku: item.sku, garment_id: gid }); onLinked?.(r.data); }
    catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <div className="flex flex-wrap items-center gap-3 py-3 border-b last:border-b-0" style={{ borderColor: "var(--border)" }} data-testid={`sku-row-${tid}`}>
      <div className="min-w-[220px] flex-1">
        <div className="font-medium text-sm">SKU {item.sku}</div>
        <div className="text-xs opacity-60">{item.product_name || "—"} · {item.quantity} pz{item.orders?.length ? ` · ${item.orders.join(", ")}` : ""}</div>
      </div>
      <select className="input-dark max-w-xs text-xs" value={gid} onChange={e => setGid(e.target.value)} data-testid={`sku-select-${tid}`}>
        <option value="">Scegli il capo…</option>
        {garments.map(g => <option key={g.id} value={g.id}>{g.code} — {g.name}</option>)}
      </select>
      <button disabled={!gid || busy} onClick={link} className="btn-gold inline-flex items-center gap-2 text-xs" data-testid={`sku-link-${tid}`}>
        <Link2 size={12}/> {busy ? "…" : "Collega"}
      </button>
      {err && <div className="w-full text-xs text-red-600">{err}</div>}
    </div>
  );
}

export function SkuMatcherPanel({ onChange }) {
  const garments = useGarmentOptions();
  const [items, setItems] = useState(null);
  const [maps, setMaps] = useState([]);
  const load = () => {
    api.get("/sku-mappings/unmatched").then(r => setItems(r.data));
    api.get("/sku-mappings").then(r => setMaps(r.data));
  };
  useEffect(() => { load(); }, []);
  const changed = () => { load(); onChange?.(); };
  const remove = async (m) => {
    if (!window.confirm(`Rimuovere il collegamento SKU ${m.sku}? I prossimi ordini con questo SKU non saranno più riconosciuti; gli ordini già collegati restano invariati.`)) return;
    await api.delete(`/sku-mappings/${m.id}`); changed();
  };
  if (!items) return null;
  return (
    <div className="card-dark p-6 mb-8" data-testid="sku-matcher-panel">
      <div className="flex items-center gap-3 mb-1"><PackageSearch size={16}/><div className="label-caps">Prodotti da abbinare</div>
        {items.length > 0 && <span className="chip chip-red" data-testid="sku-unmatched-count">{items.length}</span>}</div>
      <p className="text-xs opacity-60 mb-4">SKU arrivati negli ordini che non corrispondono a nessun capo. Collegali una volta: gli ordini aperti vengono aggiornati e i prossimi saranno riconosciuti da soli.</p>
      {items.length === 0
        ? <div className="text-sm opacity-60" data-testid="sku-unmatched-empty">Tutti i prodotti degli ordini aperti sono riconosciuti.</div>
        : items.map(it => <SkuLinkRow key={it.sku} item={it} garments={garments} onLinked={changed}/>)}
      {maps.length > 0 && (
        <details className="mt-5" data-testid="sku-mappings-list">
          <summary className="text-xs uppercase tracking-widest cursor-pointer opacity-70">Collegamenti salvati ({maps.length})</summary>
          <div className="mt-3 space-y-2">
            {maps.map(m => (
              <div key={m.id} className="flex items-center justify-between text-xs" data-testid={`sku-mapping-${m.id}`}>
                <span>SKU <b>{m.sku}</b> → {m.garment ? `${m.garment.code} — ${m.garment.name}` : "capo eliminato"}</span>
                <button onClick={() => remove(m)} className="opacity-60 hover:opacity-100" data-testid={`sku-mapping-delete-${m.id}`}><Trash2 size={12}/></button>
              </div>
            ))}
          </div>
        </details>
      )}
    </div>
  );
}
